import { Authority } from '../../../shared/enums/authority.enum';
import { FeatureIdentifier } from '../../../shared/enums/feature-identifier.enum';
import { ManagerByPlaceType } from '../../../shared/enums/manager-by-place.enum';
import { Status } from '../../../shared/enums/status.enum';
import { SubscriptionStatus } from '../../../shared/enums/subscription-status.enum';
import { UtilHelper } from '../../../shared/helpers/utils.helper';
import { Photo } from '../../../shared/models/photo.model';
import { ShortLink } from '../../../shared/models/shortlink.model';
import { Translation } from '../../../shared/models/translation.model';
import { Place } from '../../place/models/place.model';
import { BusinessType } from '../enums/business-type.enum';
import { OpenStatus } from '../enums/open-status.enum';
import { FeatureInTest } from '../../../shared/models/feature-in-test.model';

export class Store {
	id: number;
	storeUuid: string;
	establishmentName: string;
	tradeName: string;
	establishmentPhone: string;
	cnpj: string;
	zipCode: string;
	state: string;
	city: string;
	neighborhood: string;
	street: string;
	number: string;
	complement: string;
	contactName: string;
	cpf: string;
	howKnow: string;
	contactEmail: string;
	contactMobilePhone: string;
	description: string;
	coverImage: Photo;
	logoImage: Photo;
	averageRating: number;
	numberReviews: number;
	businessType: BusinessType;
	allowPayLater: boolean;
	status: Status;
	openingStatus: OpenStatus;
	lat?: number;
	lon?: number;
	// changeGeolocation: boolean;
	allowOnlinePayment: boolean; // oferecer opção para pagamento online
	optionForHere: boolean; // oferece opção para comer no local
	offerPickup: boolean; // oferece opção para retirada
	offerDriveIn: boolean; // oferece opção para retirada
	acceptDelivery: boolean;
	allowOrderReservation: boolean;
	allowOnlyOrderReservation: boolean;
	place: Place;
	shortLink: ShortLink;
	nextClosingDate: number;
	nextOpeningDate: number;
	authority: Authority;
	paymentCustomerId: string;
	minimumDeliveryPrice: number;
	featureIdentifiers: Array<FeatureIdentifier>;
	subscriptionStatus: SubscriptionStatus;
	featureInTest: Array<FeatureInTest>;

	// código cupom de desconto
	coupon: string;

	// Filial
	validateCnpj: boolean;
	branch: boolean;
	preRegistration: boolean;
	storeReference: number;
	userRegistration: number;

	// Cadastro place
	placeId?: number;
	placeManagementsType: ManagerByPlaceType;

	// aux view
	fullAddress: string;
	descriptionTranslations: Translation;

	constructor(obj: any = { }) {
		Object.assign(this, obj);

		if (this.status != null && this.status['code'] == null) {
			this.status = UtilHelper.getEnumByCod(this.status, Status);
		} else if (this.id && this.status == null) {
			this.status = Status.UNKNOWN;
		}
		if (!this.contactEmail) {
			this.contactEmail = "";
		}
		if (this.number == "null") {
			this.number = null;
		}
		if (this.authority != null && this.authority['code'] == null) {
			this.authority = UtilHelper.getEnumByCod(this.authority, Authority);
		}
		this.fullAddress = this.getFullFormattedAddress();

		// this.featureInTest = [
		// 	{
		// 		identifiers: FeatureIdentifier.QUEUE,
		// 		status: SubscriptionStatus.IN_TEST,
		// 		endDate: "2022-11-01"
		// 	},
		// 	{
		// 		identifiers: FeatureIdentifier.FULL_ORDER,
		// 		status: SubscriptionStatus.TRIAL_EXPIRED,
		// 		endDate: "2022-03-01"
		// 	}
		// ];
	}

	getFullFormattedAddress(): string {
		let address: string = "";
		if (this.street) {
			address += this.street;
		}
		if (this.number) {
			address += ", " + (this.number == "0" ? "S/N" : this.number);
		}
		if (this.complement) {
			address += ", " + this.complement;
		}
		if (this.neighborhood) {
			address += " - " + this.neighborhood;
		}
		if (this.city) {
			address += ", " + this.city;
		}
		if (this.state) {
			address += " - " + this.state;
		}
		return address;
	}

	getStreetFormattedAddress(): string {
		let address: string = "";
		if (this.street) {
			address += this.street;
		}
		if (this.number) {
			address += ", " + this.number;
		}
		return address;
	}

	// Ap 2 - Centro, Curitiba - PR
	getComplementFormattedAddress(): string {
		let address: string = "";
		if (this.complement) {
			address += this.complement;
		}
		if (this.neighborhood) {
			address += (address ? " - " : " ") + this.neighborhood;
		}
		if (this.city) {
			address += ", " + this.city;
		}
		if (this.state) {
			address += " - " + this.state;
		}
		return address;
	}

	isOnlyMenu(): boolean {
		return !this.acceptDelivery && !this.offerPickup && !this.optionForHere && !this.offerDriveIn;
	}

	isDataIncomplete(): boolean {
		return !this.establishmentName || !this.cnpj || !this.zipCode;
	}
}

/**
 * Usado no form para a seção dos campos de dados gerais
 */
export class StoreDataForm {
	id: number;
	establishmentName: string;
	tradeName: string;
	establishmentPhone: string;
	cnpj: string;
	contactName: string;
	cpf: string;
	contactEmail: string;
	contactMobilePhone: string;

	constructor(store?: Store) {
		if (store) {
			this.id = store.id;
			this.establishmentName = store.establishmentName;
			this.tradeName = store.tradeName;
			this.establishmentPhone = store.establishmentPhone;
			this.cnpj = store.cnpj;
			this.contactName = store.contactName;
			this.cpf = store.cpf;
			this.contactEmail = store.contactEmail
			this.contactMobilePhone = store.contactMobilePhone;
		}
	}
}

/**
 * Usado no form para a seção dos campos de endereço
 */
export class StoreAddressForm {
	zipCode: string;
	state: string;
	city: string;
	neighborhood: string;
	street: string;
	number: string;
	complement: string;
	lat: number;
	lon: number;

	constructor(store?: Store) {
		if (store) {
			this.zipCode = store.zipCode;
			this.state = store.state;
			this.city = store.city;
			this.neighborhood = store.neighborhood;
			this.street = store.street;
			this.number = store.number;
			this.complement = store.complement
			this.lat = store.lat;
			this.lon = store.lat;
		}
	}

	getFullFormattedAddress(): string {
		let address: string = "";
		if (this.street) {
			address += this.street;
		}
		if (this.number) {
			address += ", " + this.number;
		}
		if (this.complement) {
			address += ", " + this.complement;
		}
		if (this.neighborhood) {
			address += " - " + this.neighborhood;
		}
		if (this.city) {
			address += ", " + this.city;
		}
		if (this.state) {
			address += " - " + this.state;
		}
		return address;
	}

	getStreetFormattedAddress(): string {
		let address: string = "";
		if (this.street) {
			address += this.street;
		}
		if (this.number) {
			address += ", " + this.number;
		}
		return address;
	}

	// Ap 2 - Centro, Curitiba - PR
	getComplementFormattedAddress(): string {
		let address: string = "";
		if (this.complement) {
			address += this.complement;
		}
		if (this.neighborhood) {
			address += (address ? " - " : " ") + this.neighborhood;
		}
		if (this.city) {
			address += ", " + this.city;
		}
		if (this.state) {
			address += " - " + this.state;
		}
		return address;
	}
}


// WEBPACK FOOTER //
// ./src/app/pages/store/models/store.model.ts